// @flow
import { connect } from 'react-redux';

import { loginRequest } from 'redux/User/actions';
import { loginErrorMessage, userProfile, isAuthenticated } from 'redux/User/selectors';
import Login from './Login.component';
import type { DispatchPropsType } from './Login.component';

const mapStateToProps = (state: StoreType): DashboardStore => ({
  user: userProfile(state),
  setErrorMessage: loginErrorMessage(state),
  isAuthenticated: isAuthenticated(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  login: (user) => dispatch(loginRequest(user)),
});

export default (connect(mapStateToProps, mapDispatchToProps)(Login): any);
